import { render, staticRenderFns } from "./card-box.vue?vue&type=template&id=c9d26c08&scoped=true&"
import script from "./card-box.vue?vue&type=script&lang=js&"
export * from "./card-box.vue?vue&type=script&lang=js&"
import style0 from "./card-box.vue?vue&type=style&index=0&id=c9d26c08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d26c08",
  null
  
)

export default component.exports